import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface LandingHeroData {
  title?: string;
  subtitle?: string;
  description?: string;
  primary_cta?: string;
  secondary_cta?: string;
  primary_cta_link?: string;
  secondary_cta_link?: string;
  stats?: Array<{
    value: string;
    label: string;
  }>;
  background_image?: string;
  background_video_url?: string;
}

export const useLandingHeroContent = () => {
  const [data, setData] = useState<LandingHeroData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data: heroData, error: fetchError } = await supabase
        .from('landing_hero_content')
        .select('*')
        .single();

      if (fetchError) throw fetchError;

      // Transform the data to match our interface
      if (heroData) {
        setData({
          ...heroData,
          stats: Array.isArray(heroData.stats) ? heroData.stats as Array<{ value: string; label: string }> : undefined
        });
      }
      setError(null);
    } catch (err: any) {
      console.error('Error fetching landing hero content:', err);
      setError(err.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, loading, error, refetch: fetchData };
};
